import { render, staticRenderFns } from "./publicVerDialog.vue?vue&type=template&id=524e93d5&"
import script from "./publicVerDialog.vue?vue&type=script&lang=js&"
export * from "./publicVerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports